export function clearGoogleScripts() {
    const googleScriptsList = document.querySelectorAll('script[src*="maps.googleapis.com"],script[src*="apis.google.com"]');
    for (const elem of googleScriptsList) {
        elem.remove();
    }
}

export function getBrowserLanguages() {
    const language = window.navigator.language || window.navigator.userLanguage;
    const languages = window.navigator.languages || [];

    return {
        language,
        languages
    };
}
